export default __webpack_public_path__ + "static/media/sort.16b018f8.svg";